export default __webpack_public_path__ + "static/media/Chat-Numbers-System-16.e7fa58e4.svg";